import React, { useEffect } from "react";
import { Box, Flex, Image } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { setIsContactVisible } from "@root/store/slices/features";
import { ContactUsForm } from "@root/components";
import ContactUsHeader from "@assets/images/contactUsHeader.svg";
import { StyledDashboardLayoutChildContainer } from "@root/components/common/style";

export const ContactUsScreen: React.FC = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setIsContactVisible(true));
	}, []);

	return (
		<StyledDashboardLayoutChildContainer
			overflowY={'scroll'}
		>
			<Image
				src={ContactUsHeader}
				alt="Contact Us Header"
				width="100%"
				height="auto"
			/>
			<Flex
				flex="1"
				justifyContent="center"
				width="100%"
				px={4}
				pt={"24px"}
				mb={"100px"}
			>
				<Box
					w={{ base: "100%", md: "60%", lg: "35%" }}
					borderRadius="16px"
					border="1px"
					backgroundColor="primary.500"
					p={{ base: "24px 4px", sm: "24px" }}
					borderColor="black.400"
				>
					<ContactUsForm />
				</Box>
			</Flex>
		</StyledDashboardLayoutChildContainer>
	);
};
